import {BackendConfigManager} from 'components/Backend/Config/Manager';

export const title = '參數設定';

export const orderNum = 99;
export default BackendConfigManager;
